/**
 * 项目匹配手册
 */
const state = {
  logName: "登录", // 放置登录信息，不要进行修改！！！
  showAppCode: false, // 存放更改app二维码状态的值，不要进行修改！！！
  bannerNavContainer: "", //底部菜单
  virtualSrc: "", // 虚拟体验页面iframe地址,空则自动切换为显示时间页面
  monitorLeverColor: [
    // 环境监测等级颜色表，根据等级渲染颜色
    {
      lever: 1,
      color: "#0074f6"
    }
  ],
  imagesFile: "zhsdImages", // 图片文件夹名称
  token: "", // 登录接口获取的token
  /**
   * 服务器图片资源管理
   */
  //从服务器获取的静态资源存储
  serverImages: {
    logoText: "", //登录后的欢迎文字
    logoImage: "", //项目logo
    homeBannerImages1: "", //首页轮播图图片
    homeBannerImages2: "", //首页轮播图图片
    homeBannerImages3: "", //首页轮播图图片
    homeBannerImages4: "", //首页轮播图图片
    videoImages: "", //首页视频封面图
    videoUrl: "", //首页视频链接
    videoText: "", //首页视频旁边介绍文字
    homeResourcesImages1: "", //首页湿地资源背景图
    homeResourcesImages2: "", //首页湿地资源背景图
    homeResourcesImages3: "", //首页湿地资源背景图
    homePopularScienceImages: "", //首页湿地科普图片
    homePopularScienceText: "", //首页湿地科普文字
    contactText1: "", //首页联系方式1
    contactText2: "", //首页联系方式2
    copyright: "", //首页版权所有
    support: "", //首页技术支持
    wxImages: "", //微信公众号二维码
    menuBannerImages1: "", //菜单背景图1
    menuBannerImages2: "", //菜单背景图2
    menuBannerImages3: "", //菜单背景图3
    menuBannerImages4: "", //菜单背景图4
    appImages: "", //手机app二维码
    titleImages: "", //项目名称图片
    infoWindowContent: `暂无数据`, //部门概况中的地图弹窗内容
    coord: '<a href="" class="coord" lng="117.068474" lat="28.696901"></a>', //部门概况中的地图弹窗定位
    aPictureCoordinate: "" //一张图坐标
  },
  manualServerImages: {
    logoText: "001", //顶部的欢迎文字
    titleImages: "002", //项目名称图片
    logoImage: "003", //项目logo
    wxImages: "004", //微信公众号二维码
    appImages: "005", //手机app二维码
    homeBannerImages1: "006", //首页轮播图图片
    homeBannerImages2: "007", //首页轮播图图片
    homeBannerImages3: "008", //首页轮播图图片
    homeBannerImages4: "009", //首页轮播图图片
    videoImages: "010", //首页视频封面图
    videoUrl: "011", //首页视频链接
    videoText: "012", //首页视频旁边介绍文字
    homeResourcesImages1: "013", //首页湿地资源背景图
    homeResourcesImages2: "014", //首页湿地资源背景图
    homeResourcesImages3: "015", //首页湿地资源背景图
    homePopularScienceImages: "016", //首页湿地科普图片
    homePopularScienceText: "017", //首页湿地科普文字
    contactText1: "018", //首页联系方式1
    contactText2: "019", //首页联系方式2
    copyright: "020", //首页版权所有
    support: "021", //首页技术支持
    menuBannerImages1: "022", //菜单背景图1
    menuBannerImages2: "023", //菜单背景图2
    menuBannerImages3: "024", //菜单背景图3
    menuBannerImages4: "025", //菜单背景图4
    infoWindowContent: "026", //部门概况中的地图弹窗内容
    coord: "027", //部门概况中的地图弹窗定位
    aPictureCoordinate: "033" //一张图坐标
  },
  monitorDictionaries: [
    // 环境监测字典表，添加新数据需要元素名称加图片和颜色
    // 气象
    {
      name: "空气温度",
      color: "#0074f6"
    },
    {
      name: "空气湿度",
      color: "#25f89c"
    },
    {
      name: "风向",
      color: "#0700ff"
    },
    {
      name: "风速",
      color: "#fa682f"
    },
    {
      name: "雨量",
      color: "#258df8"
    },
    {
      name: "气压",
      color: "#f82525"
    },
    {
      name: "TBQ辐射",
      color: "#6C70F5"
    },
    {
      name: "辐射累计",
      color: "#B1B9E0"
    },
    {
      name: "雨量累计",
      color: "#1296DB"
    },
    // 空气
    {
      name: "二氧化硫",
      color: "#b8be19"
    },
    {
      name: "2.5微米颗粒物",
      color: "#ef9c00"
    },
    {
      name: "10微米颗粒物",
      color: "#ef9c00"
    },
    {
      name: "二氧化碳",
      color: "#49ae12"
    },
    {
      name: "负氧离子",
      color: "#b733d7"
    },
    // 水质
    {
      name: "水温",
      color: "#1484f7"
    },
    {
      name: "酸碱度",
      color: "#fc5959"
    },
    {
      name: "水电导率",
      color: "#7425f8"
    },
    {
      name: "溶解氧",
      color: "#51d8ff"
    },
    {
      name: "化学需氧量",
      color: "#fef345"
    },
    {
      name: "总磷",
      color: "#d99f00"
    },
    {
      name: "总氮",
      color: "#9225f8"
    },
    {
      name: "浊度",
      color: "#4c4402"
    },
    {
      name: "水位",
      color: "#1890ff"
    },
    // 土壤
    {
      name: "土壤温度",
      color: "#248cf8"
    },
    {
      name: "土壤含水率",
      color: "#85bffa"
    },
    {
      name: "土壤电导率",
      color: "#87CEEB"
    }
  ]
};

export default {
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/manual.js